export * from './StaticImageHelper';
export { default as StaticImageHelper } from './StaticImageHelper';
